export enum MembershipEventStatus {
  PENDING = 'pending',
  PENDING_OWNER_APPROVAL = 'pendingOwnerApproval',
  ACCEPTED = 'accepted',
  EXPIRED = 'expired',
  REVOKED = 'revoked',
  OWNER_REJECTED = 'ownerRejected',
  CANCELLED = 'cancelled',
}
